import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Loading from "../../Shared/Loading/Loading";

const CheckOutForm = ({ packagePrice, firstName, lastName, email, id }) => {
  const [cardError, setCardError] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [processing, setProcessing] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    fetch("https://fancy-nomad-server.vercel.app/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ packagePrice }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [packagePrice]);




  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    const card = elements.getElement(CardElement);

    if (card == null) {
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });

    if (error) {
      setCardError(error.message);
    } else {
      setCardError("");
    }
    setProcessing(true);
    const { paymentIntent, error: confirmError } =
      await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: card,
          billing_details: {
            name: firstName + " " + lastName,
            email: email,
          },
        },
      });

    if (confirmError) {
      setCardError(confirmError.message);
      return;
    }

    if (paymentIntent.status === "succeeded") {
      const payment = {
        bookingId: id,
        email: email,
        price: packagePrice,
        transactionId: paymentIntent.id,
      };

      fetch("https://fancy-nomad-server.vercel.app/payUsersInfo", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(payment),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            toast.success("Pyment Successfull");
            setTransactionId(paymentIntent.id);
          }
        });
      setProcessing(false);
    }
  };

  if (!clientSecret) {
    <Loading></Loading>
  }
    return (
      <form onSubmit={handleSubmit}>
        <CardElement
          options={{
            style: {
              base: {
                fontSize: "16px",
                color: "#424770",
                "::placeholder": {
                  color: "#aab7c4",
                },
              },
              invalid: {
                color: "#9e2146",
              },
            },
          }}
        />
        <button
          className="px-3 py-1 bg-blue-400 hover:bg-blue-700 uppercase text-semibold text-white rounded-sm outline-none mt-5"
          type="submit"
          disabled={!stripe || !clientSecret || processing}
        >
          Pay
        </button>
        <small className="text-red-500 block mt-3">{cardError}</small>
        {transactionId && (
          <p className="text-green-500 block mt-3">
            <strong className="text-black">TransactionId</strong> :{" "}
            {transactionId}
          </p>
        )}
      </form>
    );
};

export default CheckOutForm;
